define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/html",
	"./util"
], function(declare,StringRen,html,util) {
	
	return declare(StringRen, {
		/**
		 * Add (un)shared icon to section
		 */
		toHtmlStatic: function(ctx, h, refNode, actionData) {
			var bAdHoc = util.isSectionAdHoc(ctx);
			if (bAdHoc) {
				return this.inherited(arguments);
			}
			
			// render definition name in bold
			util.renderSectionDefinition(ctx, null, refNode);

			// render section name and icon unless a non-shared section
			if (util.isSectionShared(ctx) || util.isSectionUnlinked(ctx)) {
				this.inherited(arguments);
				util.renderSectionIcon(ctx, null, refNode);
			}

			return true;
		},
		
		/**
		 * Do not allow section names to wrap
		 */
		_getCSS: function(type, format) {
			return this.inherited(arguments) + " nowrap";
		}
	});
});